// Copyright 2016 Sorama B.V.

import { DOM, bindable, bindingMode, customAttribute, inject } from "aurelia-framework";

@customAttribute("parent-class", bindingMode.twoWay)
@inject(DOM.Element)
export class ParentClass {
    //#region Injected Services
    private element: HTMLElement;
    //#endregion

    //#region Attribute Values
    @bindable parent: string;
    @bindable class: string;
    //#endregion

    //#region Fields
    private parentElement: Element;
    //#endregion

    constructor(element: HTMLElement) {
        this.element = element;
    }

    public attached(): void {
        // Select the element with the parentselector which is a parent of the current element
        const possibleParents = document.querySelectorAll(this.parent);

        this.parentElement = this.matchParent(this.element.parentElement, possibleParents);

        if (!this.parent) {
            // No parent found that matches the parent selector, do nothing
            return;
        }

        // Add the specified class(es) to the parent
        this.class.split(" ").forEach((x) => this.parentElement.classList.add(x));
    }

    public detached(): void {
        if (!this.parent) {
            return;
        }

        // Remove the specified class(es) from the parent
        this.class.split(" ").forEach((x) => this.parentElement.classList.remove(x));
    }

    //#region Helpers

    private matchParent(element: Element, elements: NodeListOf<Element>): Element {
        if (!element) {
            return;
        }

        // See if the element matches any of the elements and return the element if there is a match
        for (const elementName in elements) {
            if (elements[elementName] === element) {
                return element;
            }
        }

        // If not, call this function for the direct parent of the element
        return this.matchParent(element.parentElement, elements);
    }

    //#endregion
}
